export enum WeightUnit {
  KG = 'kg',
  LB = 'lb',
}

export enum HeightUnit {
  CM = 'cm',
  IN = 'in',
}

export enum TimeFormat {
  H24 = '24h',
  H12 = '12h',
}

export enum DateFormat {
  DMY = 'DD/MM/YYYY',         // e.g., 09/04/2025
  MDY = 'MM/DD/YYYY',         // e.g., 04/09/2025
  YMD = 'YYYY/MM/DD',         // e.g., 2025/04/09
  MonDayYear = 'MMM DD, YYYY' // e.g., Apr 09, 2025
}
